import filesFromFolder from "./getFilesFromFolder";
import config from "./config";
import axios from "axios";

const deleteFiles = async (identifier) => {
  const data = await filesFromFolder(identifier);

  if (data) {
    const objects = data.map((i) => {
      return { Key: i };
    });

    objects.push({
      Key: identifier,
    });

    const args = {
      Delete: {
        Objects: objects,
      },
    };

    const [url, params] = await config("deleteObjects", args);

    return await axios.post(url, params);
  }
};

export default deleteFiles;
